<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="计划名称">
              <a-input placeholder="请输入计划名称" v-model="queryParam.planName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="planCycle" slot-scope="priority, record">
          <span v-if="record.planCycle == '0 0/15 * * * ?'">
            <a-tag color="#52c41a">15分钟</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0/30 * * * ?'">
            <a-tag color="#52c41a">30分钟</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/1 * * ?'">
            <a-tag color="#52c41a">1小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/2 * * ?'">
            <a-tag color="#52c41a">2小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/3 * * ?'">
            <a-tag color="#52c41a">3小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/4 * * ?'">
            <a-tag color="#52c41a">4小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/6 * * ?'">
            <a-tag color="#52c41a">6小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/8 * * ?'">
            <a-tag color="#52c41a">8小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/12 * * ?'">
            <a-tag color="#52c41a">12小时</a-tag>
          </span>
          <span v-else-if="record.planCycle == '0 0 0/24 * * ?'">
            <a-tag color="#52c41a">24小时</a-tag>
          </span>
          <span v-else="record.planCycleType == '2'">
            <a-tag color="#52c41a">每日&nbsp;{{ record.planCycle | planCycleFilter }}</a-tag>
          </span>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleTo3d()">巡检路线</a>
          <a-divider type="vertical" /> -->
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.planStatus == 0 || record.planStatus == 2" />
          <a @click="handlePublish(record)" v-if="record.planStatus == 0 || record.planStatus == 2">发布</a>
          <a-divider type="vertical" v-if="record.planStatus == 1" />
          <a @click="handleHangUp(record)" v-if="record.planStatus == 1">挂起</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <yw-intelligent-patrol-plan-modal @ok="modalFormOk" ref="modalForm"></yw-intelligent-patrol-plan-modal>
  </a-card>
</template>

<script>
import { postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import YwIntelligentPatrolPlanModal from './modules/YwIntelligentPatrolPlanModal'
import CronParser from 'cron-parser'
import dateFormat from '@/components/jeecg/JEasyCron/format-date'

export default {
  name: 'YwIntelligentPatrolPlanList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    YwIntelligentPatrolPlanModal
  },
  data() {
    return {
      description: '智能巡检计划管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '计划名称',
          align: 'center',
          dataIndex: 'planName'
        },
        {
          title: '任务周期',
          align: 'center',
          dataIndex: 'planCycle',
          scopedSlots: { customRender: 'planCycle' }
        },
        {
          title: '计划类型',
          align: 'center',
          dataIndex: 'planCycleType_dictText'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '计划状态',
          align: 'center',
          dataIndex: 'planStatus_dictText'
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createBy_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/maintenance/ywIntelligentPatrolPlan/list',
        delete: '/maintenance/ywIntelligentPatrolPlan/delete',
        deleteBatch: '/maintenance/ywIntelligentPatrolPlan/deleteBatch',
        exportXlsUrl: '/maintenance/ywIntelligentPatrolPlan/exportXls',
        importExcelUrl: 'maintenance/ywIntelligentPatrolPlan/importExcel',
        publishUrl: '/maintenance/ywIntelligentPatrolPlan/publish',
        hangUpUrl: '/maintenance/ywIntelligentPatrolPlan/hangUp'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  filters: {
    planCycleFilter(val) {
      if (!val) return
      const values = val.split(' ').filter(item => !!item)
      if (!values || values.length <= 0) return
      let i = 0
      let second = values[i++]
      let minute = values[i++]
      let hour = values[i++]
      let day = values[i++]
      let month = values[i++]
      let week = values[i++]
      let year = values[i]
      let result = []
      let seconds = second.split(',')
      let minutes = minute.split(',')
      let hours = hour.split(',')
      for (let j = 0; j < hours.length; j++) {
        for (let k = 0; k < minutes.length; k++) {
          for (let m = 0; m < seconds.length; m++) {
            result.push(
              `${hours[j].length == 1 ? '0' + hours[j] : hours[j]}:${
                minutes[k].length == 1 ? '0' + minutes[k] : minutes[k]
              }:${seconds[m].length == 1 ? '0' + seconds[m] : seconds[m]}`
            )
          }
        }
      }
      return result.join('、')
    }
  },
  methods: {
    handleTo3d() {
      const iframeWindow = document.getElementById('commentIframegeneral-3d--visualView-#-')
      if (iframeWindow) {
        iframeWindow.contentWindow.postMessage('lineshow', '*')
        this.$router.push({ path: '/general/3d' })
      } else {
        this.$router.push({ path: '/general/3d', query: { path: 1 } })
      }
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'planName', text: '计划名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'planStatus', text: '计划状态', dictCode: '' })
      fieldList.push({ type: 'date', value: 'nextTime', text: '下次执行时间' })
      fieldList.push({ type: 'string', value: 'createBy', text: '创建人', dictCode: '' })
      this.superFieldList = fieldList
    },
    handlePublish(row) {
      if (row.planStatus != 0 && row.planStatus != 2) {
        this.$message.error('该状态不允许发布,请确认状态是否合法.')
        return
      }
      //发布
      postAction(this.url.publishUrl, row).then(res => {
        if (res.success) {
          this.$message.success('智能巡检计划发布成功.')
          this.searchQuery()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleHangUp(row) {
      if (row.planStatus != 1) {
        this.$message.error('该状态不允许挂起,请确认状态是否合法.')
        return
      }
      //挂起
      postAction(this.url.hangUpUrl, row).then(res => {
        if (res.success) {
          this.$message.success('智能巡检计划停用成功.')
          this.searchQuery()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
